import React, {
  FC,
  PropsWithChildren,
  ReactNode,
  memo,
  useCallback,
  useState,
} from 'react';

import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';

import { copyTextToClipboard } from '@utils/common.utils';

import Tooltip from '@components/common/Tooltip';

import useStyles from './styles.module';

interface Props extends PropsWithChildren {
  value: string | number;
  className?: string;
  icon?: ReactNode;
}

const CopyClipboard: FC<Props> = ({
  value,
  children,
  className = '',
  icon = undefined,
}) => {
  const { classes, cx } = useStyles();

  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    await copyTextToClipboard(String(value));
    setIsCopied(true);
  }, [value]);

  const handlePointerLeave = useCallback(() => {
    setTimeout(() => setIsCopied(false), 500);
  }, [setIsCopied]);

  return (
    <Tooltip
      title={isCopied ? 'Copied!' : 'Copy value to clipboard'}
      placement="top-end"
      className={cx(classes.row, className)}
    >
      <button
        onPointerLeave={handlePointerLeave}
        onClick={handleCopy}
        className={classes.box}
      >
        {children}
        {icon || <FileCopyOutlinedIcon />}
      </button>
    </Tooltip>
  );
};

export default memo(CopyClipboard);
